const commerceToolConfig = {
  clientId: process.env.NEXT_PUBLIC_ENCODED_AUTH,
  accessTokenURL: `https://auth.europe-west1.gcp.commercetools.com/oauth/token?grant_type=client_credentials`,
};
// Helper function to get the authentication token
const useGetTokenCT = async (): Promise<string | null> => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "Basic " + commerceToolConfig?.clientId);

  try {
    const response = await fetch(commerceToolConfig?.accessTokenURL, {
      method: "POST",
      headers: myHeaders,
    });
    const result = await response.json();
    return result.access_token;
  } catch (error) {
    console.error("Error fetching the token:", error);
    return null;
  }
};

export default useGetTokenCT;
